import validator from 'validator' 

export class Validation {
  static validateEmail(email: string): boolean | string {
    if (!email) {
      return "Email is required";
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      return "Invalid email address";
    }
    return true;
  }
  static validatePhoneNumber(number: string): boolean | string {
    if (!number) {
      return "Number is required";
    }

    const isValidPhoneNumber = validator.isMobilePhone(number);
    return isValidPhoneNumber;
  }
}
